import React, { useCallback } from 'react';
// import { useTranslation } from '@pascal/pascal-core';
import { INSURANCE_ACTION } from '../../enums/constants';
import { turboGameService } from '../../services/TurboGameService';

function InsurancePanel() {
  // const t = useTranslation();
  const handleInsuranceAction = useCallback((isInsurance) => {
    turboGameService.sendInsurance(isInsurance);
  }, []);

  return (
    <div className='tb-control-panel'>
      <div className='tb-boolean-btn-group'>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          type='button'
          className='tb-boolean-btn-yes'
          onClick={() => handleInsuranceAction(INSURANCE_ACTION.YES)}
          aria-label='Yes'
        >
          <span className='icon-boolean-yes' />
        </button>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <button
          type='button'
          className='tb-boolean-btn-no'
          aria-label='no'
          onClick={() => handleInsuranceAction(INSURANCE_ACTION.NO)}
        >
          <span className='icon-boolean-no' />
        </button>
      </div>
    </div>
  );
}

export default InsurancePanel;
